import useIsMobile from "../hooks/useIsMobile";

export default function SelectField({ label, value, onChange, options, half = false, placeholder, error }) {
  const isMobile = useIsMobile();
  return (
    <div style={{ flex: half ? "1 1 48%" : "1 1 100%", minWidth: half ? (isMobile ? 0 : "220px") : "auto" }}>
      <label
        style={{
          display: "block",
          fontSize: "13px",
          fontWeight: 600,
          color: "#4a3f35",
          marginBottom: "6px",
          fontFamily: "'DM Sans', sans-serif",
          letterSpacing: "0.02em",
        }}
      >
        {label}
      </label>
      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          padding: "12px 16px",
          border: error ? "2px solid #c45d3e" : "2px solid #e8e0d4",
          borderRadius: "10px",
          fontSize: "15px",
          fontFamily: "'DM Sans', sans-serif",
          backgroundColor: "#fdfbf7",
          color: value ? "#2d2418" : "#8a7e70",
          outline: "none",
          cursor: "pointer",
          boxSizing: "border-box",
        }}
      >
        {placeholder && (
          <option value="" disabled style={{ color: "#8a7e70" }}>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} style={{ color: "#2d2418" }}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && (
        <p style={{ fontSize: "12px", color: "#c45d3e", margin: "4px 0 0 0" }}>{error}</p>
      )}
    </div>
  );
}
